import { useMutation } from 'react-query';
import { message } from 'antd';
import request from '../../helpers/request';

const errorMessage = 'При добавлении комментария произошла ошибка';

const mutationFn = ({ comment, attachments, addressId }) => {
  const formData = new FormData();

  formData.append('comment', comment);

  if (attachments?.length) {
    attachments.forEach((attachment) => {
      formData.append('files', attachment);
    });
  }

  return request.post(
    `/HousingStock/address/${addressId}/comment_v2`,
    formData,
    errorMessage,
    'Error'
  );
};

const useAddFlatComment = (options) => {
  return useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data === 'Error') {
        return;
      }

      if (data.success === false) {
        message.error(data.message || errorMessage);
        return;
      }

      if (typeof options?.onSuccess === 'function') {
        options.onSuccess(data, variables);
      }
    },
  });
};

export default useAddFlatComment;
